import NewsCategoryIndex from './NewsCategoryIndex';
import NewsCategoryCreate from './NewsCategoryCreate';
import NewsCategorySettings from './NewsCategorySettings';
import NewsCategorySingle from './NewsCategorySingle';

export default function (app) {

    const settings = NewsCategorySettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    NewsCategoryIndex(app, settings);

    NewsCategoryCreate(app, settings);

    NewsCategorySingle(app, settings);

}